import * as React from "react";
import { forwardRef } from "react";
const SvgSmallCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.66634 9.66683H0.333008V8.3335H9.66634V9.66683ZM3.66634 6.6135L0.999674 3.94683L1.93967 3.00683L3.66634 4.72683L8.05967 0.333496L8.99967 1.28016L3.66634 6.6135Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgSmallCheck);
export { ForwardRef as ReactComponent };
